import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import TableHeadDeadlineManager from '@/components/TableHeadDeadlineManager/index.vue'
import TableBodyDeadlineManager from '@/components/TableBodyDeadlineManager/index.vue'
import Anchor from '@/components/Anchor/index.vue'
import MessageSuccess from '@/components/edit/MessageSuccess/index.vue'
import ModalDeadline from '@/components/edit/ModalDeadline/index.vue'

import fetch from '@/helpers/fetch'
import tableHelper from '@/helpers/table'
import { bus } from '@/main'

import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faFilter,
	faCaretUp,
	faChevronRight,
	faChevronLeft,
	faFileExcel,
	faCircleInfo,
	faFileCsv,
	faSort,
} from '@fortawesome/free-solid-svg-icons'

Vue.component('v-select', vSelect)

library.add(
	faFilter,
	faCaretUp,
	faChevronRight,
	faChevronLeft,
	faFileExcel,
	faCircleInfo,
	faFileCsv,
	faSort,
)

@Component({
	components: {
		Loader,
		TableHeadDeadlineManager,
		TableBodyDeadlineManager,
		MessageSuccess,
		Anchor,
		ModalDeadline,
	},
})
export default class DeadlineManager extends Vue {
	items: null | any[] = null
	options: object | null | any = null

	viewPage = 1
	totalPages = 0
	totalCount = 0
	countPerPage = 100

	async mounted() {
		this.setLoading(true)

		await this.fetchData()

		bus.$on('open-modal-deadline', (id) => {
			this.$store.dispatch('selectDeadlineId', id)
			this.$bvModal.show('modal-deadline')
		})
		this.setLoading(false)
	}

	async fetchData() {
		const result = await Promise.all([
			this.onFilter({}),
			fetch.get(
				'/api/deadline-manager/collections/options?options=group_name,subjects,court',
			),
			fetch.get('/api/courthouses'),
		])
		const [resData, resOptions, resCourthouses] = result

		if (resOptions.ok && resOptions.data.options) {
			this.options = resOptions.data.options

			if (resCourthouses) {
				this.options.courthouses = resCourthouses.data
			}

			if (this.options) {
				this.fields.forEach((field) => {
					if (field.options && !field.options.length) {
						let options = (this.options as object)[
							field.optionsLabel
						]

						const firstOption = options[0]

						// if (!firstOption.id) {
						options = options.map((option, index) => {
							return {
								index: index + 1,
								...option,
								exists: true,
							}
						})
						// }

						Vue.set(field, 'options', options)
					}
				})
			}
		}

		if (resData.ok && resData.data) {
			this.items = resData.data.deadlines
			this.setCountAndPages(
				resData?.data?.deadlines_aggregate?.aggregate?.totalCount,
			)
		}
	}

	setCountAndPages(totalCount) {
		if (totalCount || totalCount === 0) {
			this.totalCount = totalCount
			this.totalPages = Math.ceil(this.totalCount / this.countPerPage)
		}
	}

	setLoading(loading) {
		this.fields.forEach((field) => {
			Vue.set(field, 'loading', loading)
		})

		if (loading) {
			this.items = getLoadingItems()
		}
	}

	filters: null | object = null
	async onFilter(filter) {
		this.filters = {
			...this.filters,
			...filter,
		}

		const params = createUrlFilterParams(this.filters)

		const url =
			`/api/deadline-manager/collections/search?items=${this.countPerPage}&page=${this.viewPage}&` +
			params.join('&')

		this.setLoading(true)
		const res = await fetch.get(url)
		if (res.ok && res?.data?.deadlines) {
			this.setLoading(false)
			this.items = res?.data?.deadlines

			this.setCountAndPages(
				res?.data?.deadlines_aggregate?.aggregate?.count,
			)
		}

		return res
	}

	fields: any[] = getFields()

	async previous() {
		if (this.viewPage > 1) {
			this.setLoading(true)
			this.viewPage--
			await this.onFilter({})
			this.setLoading(false)
		}
	}

	async next() {
		if (this.viewPage < this.totalPages) {
			this.setLoading(true)
			this.viewPage++
			await this.onFilter({})
			this.setLoading(false)
		}
	}

	// downloading = false
	// csvHref = ''
	// downloadProp = 'pesquisas-mapa-tributario.csv'
	// async downloadCSV() {
	// 	this.downloading = true
	// 	const params = createUrlFilterParams(this.filters)

	// 	const url = '/api/thermometer/collections/search?' + params.join('&')
	// 	const res = await fetch.get(url)

	// 	const data = res?.data?.thermometer

	// 	const formattedData = formatDataCsv(data)

	// 	const csvContent = jsonToCSV(formattedData)

	// 	const encodedUri = encodeURI(csvContent)

	// 	this.csvHref = 'data:text/csv;charset=utf-8,\uFEFF' + encodedUri

	// 	const time = new Date().getTime() - 3 * 60 * 60 * 1000

	// 	this.downloadProp =
	// 		'pesquisas-mapa-tributario-' +
	// 		new Date(time).toISOString().substring(0, 16) +
	// 		'.csv'

	// 	await Vue.nextTick()
	// 	const link: any = this.$refs.csvLink

	// 	if (link && link.click) {
	// 		link.click()
	// 	}

	// 	this.downloading = false
	// }
}

function formatDate(date) {
	return date?.split('-')?.reverse()?.join('/')
}

function createUrlFilterParams(filter) {
	const params: any = []
	if (filter && typeof filter === 'object') {
		const keys = Object.keys(filter)

		keys.forEach((key) => {
			const value = filter[key]

			if (typeof value !== 'object') {
				if (value || value === false || value === 0) {
					params.push(`${key}=${encodeURIComponent(value)}`)
				}
			} else {
				if (value?.from) {
					params.push(`${key}_from=${encodeURIComponent(value.from)}`)
				}

				if (value?.to) {
					params.push(`${key}_to=${encodeURIComponent(value.to)}`)
				}
			}
		})
	}

	return params
}

// function jsonToCSV(list) {
// 	let csv: any = null
// 	let firstCsvLine: any = null
// 	let keys: any = null

// 	list.forEach((item) => {
// 		if (!keys) {
// 			keys = Object.keys(item)
// 			firstCsvLine = keys.map((key) => {
// 				let keyName = key
// 				return keyName + ';'
// 			})
// 			firstCsvLine.push('\n')
// 			csv = firstCsvLine.join('')
// 		}

// 		keys.forEach((key) => {
// 			let value = item[key]
// 			if (Array.isArray(value)) {
// 				value = value.join(' + ')
// 			}

// 			if (value === null || value === undefined) {
// 				value = ''
// 			}

// 			const isNumbersOnly = /^\d+$/
// 			if (
// 				value[0] === '0' &&
// 				isNumbersOnly.test(value) &&
// 				value.length !== 1
// 			) {
// 				value = "'" + value
// 			}

// 			csv += escapeSemicollon(value) + ';'
// 		})

// 		csv += '\n'
// 	})

// 	return csv
// }

// function formatDataCsv(list) {
// 	const fields = getFields()
// 	const formattedData: any = []

// 	list.forEach((item) => {
// 		const formattedItem = {}
// 		fields.forEach((field) => {
// 			if (field.onCsv !== false) {
// 				let value = item[field.fieldName]

// 				if (field.format) {
// 					value = field.format(value)
// 				}

// 				formattedItem[field.humanName] = value
// 			}
// 		})

// 		formattedData.push(formattedItem)
// 	})

// 	return formattedData
// }

// function escapeSemicollon(string) {
// 	let value = string

// 	if (value === null || value === undefined) {
// 		value = ''
// 	}

// 	if (typeof value !== 'string') {
// 		value = value.toString()
// 	}

// 	if (value.includes(';') || value.includes('\n')) {
// 		value = '"' + value + '"'
// 	}

// 	return value
// }

function getFields() {
	return [
		{
			humanName: '#',
			fieldName: 'index',
			'min-width': '49px',
			fixedColumn: true,
			loading: true,
		},
		{
			humanName: 'Cliente',
			fieldName: 'trial',
			type: 'v-select',
			optionsLabel: 'group_name',
			options: [],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				name: 'client',
				model: '',
			},
			'max-width': '250px',
			'min-width': '250px',
			fixedColumn: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAAAAAAAAA',
			loading: true,
			colSize: 6,
			format(trial) {
				return trial?.groupsRelations?.[0]?.group?.name
			},
			unformat(client) {
				return client ? client.id : null
			},
			onDatabase: true,
			createOrder: 2,
			taggable: true,
		},
		{
			humanName: 'Processo referente',
			fieldName: 'trial',
			type: 'input',
			'v-mask': '#######-##.####.#.##.####',
			filter: {
				name: 'cnj',
				model: '',
			},
			format(trial) {
				const cnj = trial?.cnj
				if (cnj && typeof cnj !== 'string') return ''
				return tableHelper.formatCNJ(cnj)
			},
			unformat(cnj) {
				if (cnj) {
					return cnj?.replace(/\./g, '')?.replace('-', '')
				}
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
		},
		{
			humanName: 'Processo principal',
			fieldName: 'trial',
			type: 'input',
			'v-mask': '#######-##.####.#.##.####',
			filter: {
				name: 'cnjMainTrial',
				model: '',
			},
			format(trial) {
				const cnj = trial?.mainTrial?.cnj
				if (cnj && typeof cnj !== 'string') return ''
				return tableHelper.formatCNJ(cnj) || '-'
			},
			unformat(cnj) {
				if (cnj) {
					return cnj?.replace(/\./g, '')?.replace('-', '')
				}
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
		},
		{
			humanName: 'Número secundário',
			fieldName: 'trial',
			type: 'number',
			filter: {
				name: 'secondaryNumber',
				model: '',
			},
			format(trial) {
				return trial?.secondaryNumbers?.length
					? trial.secondaryNumbers
							.filter((item) => item?.active) // Filtra apenas os itens ativos
							.map(
								(item) =>
									`${item?.type || '-'} - ${item?.number || '-'}`,
							)
							.join(', ') || '-'
					: '-'
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
		},
		{
			humanName: 'Tese',
			fieldName: 'subjectsDeadlinesRelations',
			width: '450px',
			type: 'v-select',
			optionsLabel: 'subjects',
			options: [],
			vSelectLabel: 'name',
			filter: {
				name: 'subject',
				model: '',
			},
			format(subject) {
				return subject?.length
					? subject.map((item) => item?.subject?.name).join(', ')
					: '-'
			},
			unformat(subject) {
				return subject?.length
					? subject.map((item) => item?.id).join(',')
					: ''
			},
			loading: true,
			multiple: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
		},
		{
			humanName: 'Data do protocolo',
			fieldName: 'protocolDate',
			'min-width': '200px',
			type: 'date',
			filter: {
				name: 'protocolDate',
				model: '',
			},
			format(value) {
				return formatDate(value)
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
		},
		{
			humanName: 'Providências',
			fieldName: 'providences',
			type: 'input-pills',
			filter: {
				name: 'providence',
				model: '',
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
		},
		{
			humanName: 'Tramitação atual',
			fieldName: 'court',
			'min-width': '190px',
			type: 'v-select',
			optionsLabel: 'court',
			options: [],
			vSelectLabel: 'name',
			filter: {
				name: 'court',
				model: '',
			},
			unformat(court) {
				return court?.id
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
		},
		{
			humanName: 'Tribunal',
			fieldName: 'courthouse',
			'min-width': '150px',
			type: 'v-select',
			optionsLabel: 'courthouses',
			options: [],
			vSelectLabel: 'name',
			filter: {
				name: 'courthouse',
				model: '',
			},
			unformat(courthouse) {
				return courthouse?.id
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
		},
		{
			humanName: 'Peculiaridade',
			fieldName: 'peculiarities',
			type: 'input',
			filter: {
				name: 'peculiarities',
				model: '',
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
		},
		{
			humanName: 'Observação',
			fieldName: 'providencesObs',
			type: 'input',
			filter: {
				name: 'providencesObs',
				model: '',
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
		},
		{
			humanName: 'Protocolado',
			fieldName: 'protocolDate',
			width: '150px',
			type: 'checkbox',
			filter: {
				name: 'protocolled',
				model: '',
			},
			getClass(value) {
				return value ? 'text-success' : 'text-danger'
			},
			format(value) {
				return value ? 'Sim' : 'Não'
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
		},
	]
}

function getLoadingItems() {
	return [
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
	]
}
